import { render, staticRenderFns } from "./LookupCommonChemistryCASRN.vue?vue&type=template&id=d04f6178"
import script from "./LookupCommonChemistryCASRN.vue?vue&type=script&lang=js"
export * from "./LookupCommonChemistryCASRN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports